<template>
    <b-card-code
        title="Add New Coupon Code"
    >
        <validation-observer ref="simpleRules">
            <b-form>
                <b-row>
                    <b-col md="6">
                        <b-form-group
                            label="Coupon Title"
                            label-for="coupon-title">
                            <validation-provider
                                #default="{ errors }"
                                name="Coupon Title"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="title"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Enter Coupon Title"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            label="Coupon Code"
                            label-for="coupon-code">
                            <validation-provider
                                #default="{ errors }"
                                name="code"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="code"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Enter Coupon Code"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            label="Discount Amount"
                            label-for="discount-amount">
                            <validation-provider
                                #default="{ errors }"
                                name="discount"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="discount"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Enter Discount Amount"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            label="Max Uses"
                            label-for="max">
                            <validation-provider
                                #default="{ errors }"
                                name="max_uses"
                                rules="required"
                            >
                                <b-form-input
                                    v-model="max_uses"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Enter Max Uses"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            label="Expires Date"
                            label-for="expires_at">
                            <validation-provider
                                #default="{ errors }"
                                name="expires_at"
                                rules="required"
                            >
                                <b-form-datepicker
                                    id="expires_at"
                                    v-model="expires_at"
                                    class="mb-1"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group
                            label="Status"
                            label-for="status">
                            <validation-provider
                                #default="{ errors }"
                                name="Status"
                                rules="required"
                            >
                                <b-form-select
                                    v-model="selected"
                                    :options="status"
                                />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12">
                        <b-button
                            type="submit"
                            variant="primary"
                            @click.prevent="validationForm"
                        >
                            Submit
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormDatepicker,
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BCardText, BFormSelect,
} from 'bootstrap-vue'
import {required, email} from '@validations'
import useJwt from "@/auth/jwt/useJwt";
import Mixin from "@core/services/mixin";
import {checkRes} from "@core/services/helper";

export default {
    mixins: [
        Mixin
    ],
    components: {
        BFormDatepicker,
        BFormSelect,
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BCardText,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
    },
    data() {
        return {
            title: null,
            code: null,
            discount: null,
            uses: null,
            max_uses: null,
            expires_at: null,
            selected: null,
            status: [
                {value: null, text: 'Please select status'},
                {value: '1', text: 'Active'},
                {value: '0', text: 'Inactive'}
            ],
            required,
        }
    },
    methods: {
        validationForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    useJwt.createCouponCodeAdmin({
                        title: this.title,
                        code: this.code,
                        discount: this.discount,
                        uses: this.uses,
                        max_uses: this.max_uses,
                        expires_at: this.expires_at,
                        status: this.selected,
                    }).then(response => {
                        if (checkRes(response.data.code)){
                            this.title = this.code = this.discount = this.uses = this.max_uses = this.expires_at = ''
                            this.$refs.simpleRules.reset();
                            this.$router.push({name: 'admin-coupon-code-add'})
                                .catch(error => {
                                    this.toastMessage('success','Coupon Code', response)
                                })
                        } else {
                            this.$router.push({name: 'admin-coupon-code-add'})
                                .catch(error => {
                                    this.toastMessage('warning','Coupon Code', response)
                                })
                        }
                    }).catch(error => {
                        console.log(error)
                    })
                }
            })
        }
    },
    mounted() {
    }
}
</script>
